import { CollectionsInsightRenderRegister, Proposition } from '@ecosystem/newron-client-collections';
import { AuthenticationProvider, injectLogger } from '@ecosystem/newron-client-lib';
import React, { lazy, Suspense } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Authentication from '@components/authentication/Authentication';
import { collectionsRegister } from '@components/collections/CollectionsRegister';
import reportWebVitals from './reportWebVitals';
import Store from '@state/Store';
import { BASE_RETAIL_PATH, COLLECTION_PATH, NOTIFICATIONS_PREFERENCES, RETAIL_ALLOWED_PATH } from '@utils/UrlUtils';
import { getInsightInfo } from '@utils/collectionUtils/CollectionUtils';
import { SubscriptionsProvider } from '@components/subscriptions/SubscriptionsProvider';
import { RootContainer } from './RootContainer';
import { feedback } from '@ecosystem/newron-design-system';
// Lazy load the app component

const App = lazy(() => import('./App'));
const queryClient = new QueryClient();

injectLogger();

collectionsRegister.forEach((collection) => {
  CollectionsInsightRenderRegister.getInstance().register(
    { proposition: Proposition.Retail, type: collection.insightType },
    {
      InsightRenderer: collection.collectionsRenderer,
      getInsightInfo: getInsightInfo(collection),
    },
  );
});

const { DotsLoader } = feedback;

export const Root: React.FC = () => (
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <Provider store={Store}>
        <AuthenticationProvider>
          <Authentication>
            <SubscriptionsProvider>
              <Routes>
                <Route
                  path={`${BASE_RETAIL_PATH}`}
                  element={<Navigate to={`${RETAIL_ALLOWED_PATH.RETAILER_OVERVIEW}`} replace />}
                />
                <Route path={`${BASE_RETAIL_PATH}/*`} element={<RootContainer />} />
                <Route
                  path={`${COLLECTION_PATH}/*`}
                  element={
                    <Suspense fallback={<DotsLoader />}>
                      <App />
                    </Suspense>
                  }
                />
                <Route
                  path={`${NOTIFICATIONS_PREFERENCES}/*`}
                  element={
                    <Suspense fallback={<DotsLoader />}>
                      <App />
                    </Suspense>
                  }
                />
              </Routes>
            </SubscriptionsProvider>
          </Authentication>
        </AuthenticationProvider>
      </Provider>
    </QueryClientProvider>
  </BrowserRouter>
);

reportWebVitals();
